import React, { useEffect, useState } from 'react';
import TopicTitle from '../../../components/topicTitle';
import styles from '../quan/index.css';

// eslint-disable-next-line react/prop-types,func-style
function TimelineH5({ content }) {
    const [url, setUrl] = useState();
    const [height, setHeight] = useState(0);

    useEffect(() => {
        console.log(content, 'content');
        // eslint-disable-next-line react/prop-types
        if (content && content.data && content.data.articleList?.length) {
            // eslint-disable-next-line react/prop-types
            setUrl(content.data.articleList[0].url);
        }
        const b_iframe = document.getElementById('b_iframe');

        window.addEventListener(
            'message',
            e => {
                if (e?.data?.type === 'timeline/resize') {
                    console.log(e.data);
                    setHeight(e.data.value);
                }
                if (e?.data?.type === 'timeline/jump') {
                    window.location.href = e.data.value;
                }
            },
            false,
        );
        b_iframe.onload = () => {};
    }, []);

    return (
        <div>
            {/* eslint-disable-next-line react/prop-types */}
            <TopicTitle title={content.title} moduleIndex={content.moduleIndex} id={content.id} />
            <div className={styles.category}>
                <iframe id="b_iframe" style={{ border: 0, width: '100%', height }} scrolling="no" src={url} />
            </div>
        </div>
    );
}

export default TimelineH5;
